import { CKEditor } from '@ckeditor/ckeditor5-react';
import { BalloonToolbar, DecoupledEditor } from 'shared/domains/pleditor@next';
import { useIsLayoutReady } from '../hooks/useIsLayoutReady';
import { AppApiConnector } from '../plugins/AppApiConnector';
import { TopToolbar } from '../plugins/TopToolbar';
import { PREVIEW_PLUGINS } from '../previewPlugins';
import { BasePleditorStyles, PleditorContainer, PleditorToolbarContainer, PleditorWrapper } from '../styled';
import { EditorContainer } from './styled';
export function NotesEditor(props) {
    const { data, placeholder, onChange } = props;
    const isLayoutReady = useIsLayoutReady();
    const toolbarItems = [
        'undo',
        'redo',
        '|',
        'heading',
        '|',
        'bold',
        'italic',
        'strikethrough',
        'underline',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        'outdent',
        'indent',
    ];
    const config = {
        licenseKey: process.env.PLEDITOR_LICENSE_KEY,
        extraPlugins: [...PREVIEW_PLUGINS, AppApiConnector, TopToolbar, BalloonToolbar],
        toolbar: {
            shouldNotGroupWhenFull: true,
            items: toolbarItems,
        },
        balloonToolbar: { items: ['bold', 'italic', 'strikethrough', 'underline'] },
        placeholder,
    };
    const handleReady = (editor) => {
        editor.model.document.on('change:data', () => {
            onChange(editor.getData());
        });
    };
    return (<EditorContainer>
      <PleditorToolbarContainer $noMargin/>
      <BasePleditorStyles />
      <PleditorWrapper>
        <PleditorContainer>
          {isLayoutReady && (<CKEditor data={data} config={config} editor={DecoupledEditor} onReady={handleReady}/>)}
        </PleditorContainer>
      </PleditorWrapper>
    </EditorContainer>);
}
